export const INVITATION_ID = 'INVITATION_ID'
export const INVITATION_LINK_ID = 'INVITATION_LINK_ID'
